import React, { memo } from "react";
import { BADI_COLORS, Flex, Spacer, Text } from "@badi/badi-components";
import { translate } from "base/shared/Localization";
import { useDamageCoverage } from "modules/damage-coverage-hook";
import DamageCoverageIcon from "./damage-coverage.svg";

const BookingFooter = ({ children = null }) => {
  const damageCoverageActive = useDamageCoverage();

  return (
    <Flex
      direction="column"
      gutter={1}
      justify="spaceBetween"
      md={{
        justify: "flexEnd",
        direction: "row",
        gutter: 2,
        alignItems: "center",
      }}
    >
      {damageCoverageActive && (
        <Spacer md={{ right: 3 }} right={0}>
          <Flex alignItems="center" gutter={1}>
            <DamageCoverageIcon style={{ display: "block" }} />
            <Text
              align="center"
              body="12-Regular"
              color={BADI_COLORS.NEUTRAL.NEUTRAL_80}
              dataQa="damage-coverage-disclaimer"
            >
              {translate("booking.flow_damage.coverage.disclaimer")}
            </Text>
          </Flex>
        </Spacer>
      )}
      <Flex alignItems="center" gutter={1}>
        {children}
      </Flex>
    </Flex>
  );
};

export default memo(BookingFooter);
